import { useFirestore } from "reactfire"
import { useAuth } from "reactfire"
import { collection, addDoc, query, where, getDocs, deleteDoc } from "firebase/firestore"

/**
 * Hook para registrar actividad en Firestore.
 * Uso: const { registrar } = useActividad()
 *      await registrar({ accion: "creó", entidad: "apoderado", nombre: "Juan", unidadId: "bandada" })
 */
export function useActividad() {
  const firestore = useFirestore()
  const auth      = useAuth()

  const registrar = async ({ accion, entidad, nombre, unidadId, detalle = null }) => {
    try {
      const ahora    = Math.floor(Date.now() / 1000)
      const hace7d   = ahora - 7 * 24 * 60 * 60

      // 1. Guardar el nuevo registro
      await addDoc(collection(firestore, "actividad"), {
        accion,                               // "creó", "editó", "eliminó", etc.
        entidad,                              // "apoderado", "cuota", "egreso", "ítem"
        nombre,                               // nombre del elemento afectado
        unidadId,                             // unidad donde ocurrió
        detalle,                              // info extra opcional
        usuario: auth.currentUser?.email || "desconocido",
        fecha:   { seconds: ahora },
      })

      // 2. Limpiar registros de más de 7 días (sin Cloud Functions)
      const viejosSnap = await getDocs(
        query(
          collection(firestore, "actividad"),
          where("fecha.seconds", "<", hace7d)
        )
      )
      await Promise.all(viejosSnap.docs.map(d => deleteDoc(d.ref)))
    } catch (err) {
      // No interrumpir el flujo principal si falla el registro
      console.warn("Error registrando actividad:", err)
    }
  }

  return { registrar }
}